import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/partner-quota-action";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { initialFilter, initialValue } from "../PartnerQuotaUIHelpers";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import { PartnerQuotaHistoryDetails } from "./PartnerQuotaHistoryDetails";
import { PartnerQuotaHistoryMain } from "./PartnerQuotaHistoryMain";
import * as queryString from 'query-string'

export const PartnerQuotaHistoryPage = () => {
  const {search} = useLocation()
  const {area, livestock, partner} = queryString.parse(search)

  const dispatch = useDispatch();

  useEffect(() => {
    const params = {...initialFilter, pageNumber: 1, pageSize: 1, filter: {thk_area_uuid: area, thk_livestock_uuid: livestock, thk_partner_uuid: partner}}

    dispatch(actions.fetchPartnerQuotaGroups(params))
    dispatch(actions.fetchPartnerQuotas({...params, pageSize: null}))
  }, [area, livestock, partner]);

  return (
    <>
      <PartnerQuotaHistoryMain />
      <PartnerQuotaHistoryDetails/>
    </>
  );
};
